
import { RootStoreModel } from "@stores/RootStore";
import { ItemModelType, WorkspaceModelType } from "@stores/WorkspaceStore";

export const showInWorkspace = (
    rootStore: RootStoreModel,
    itemId: string,
    workspace: WorkspaceModelType,
    parentId?: string
) => {
    const itemMST = workspace.items.get(itemId);
    if (!itemMST) {
        return;
    }
    workspace.setScrollIntoViewId(itemMST.id);
    const parentPaths = itemMST.getParentPaths();
    const targetPath = getTargetParentPath(parentPaths, parentId);
    const selectedLibraryId = getLibraryIdFromPath(workspace, targetPath)
        || workspace.findLibraryIdForItem(itemId);
    if (selectedLibraryId) {
        workspace.setSelectedLibraryId(selectedLibraryId);
    }
    workspace.setView(itemMST.defaultView);

    if (targetPath) {
        for (const parentId of targetPath) {
            const parentItem = workspace.items.get(parentId)!;
            parentItem.setExpanded(true);
        }
    }

    rootStore.search.setTextInput('');
}

function getTargetParentPath(parentPaths: string[][], parentId?: string): string[] | null {
    if (parentPaths.length === 0) {
        return null;
    }

    if (parentId) {
        return parentPaths.find(parentPath => parentPath.includes(parentId)) || parentPaths[0];
    }

    return parentPaths[0];
}

function getLibraryIdFromPath(workspace: WorkspaceModelType, parentPath: string[] | null): string | null {
    if (!parentPath) {
        return null;
    }

    return parentPath.find(parentId => {
        const parentItem = workspace.items.get(parentId) as ItemModelType | undefined;
        return parentItem?.isLibrary === true;
    }) || null;
}
